// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__DZ82I","wrapper":"footer_wrapper__+SLT3","nav":"footer_nav__x+JyC","navItem":"footer_navItem__SIB7B"};